<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-solution.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white banner-text mb--0">汽車業服務方案</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">解決方案</h2>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/s1-1.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">端到端智能工作空間</div>
						<div class="t2">
							✅ 深度融合戰略規劃與日常經營全流程<br>
							✅ 定向破解車企多領域、長鏈條、場景碎片化難題<br>
							✅ 實現AI能力與任務執行的無縫集成，支援敏捷構建企業級AI協作體系
						</div>
					</div>
				</div>
				<div class="solution solution-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">數據智能諮詢服務</div>
						<div class="t2">
							✅ 基於超7億用戶跨域數據構建動態畫像<br>
							✅ 通過線索增強、競品分析、個性化話術提升轉化率<br>
							✅ 實現用戶標籤維度從20+到500+的躍遷，精準定位高潛客戶群
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/s1-2.jpg" style="border-radius: 12px;">
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/s1-3.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">全鏈路線索轉化平台CALO</div>
						<div class="t2">
							✅ 智能獲客戶引擎：建立主動式銷售模型，替代傳統廣告被動獲客戶<br>
							✅ 到店轉化引擎：通過AI意向評分提升邀約到店率30%+<br>
							✅ AI語音工牌系統：實現銷售流程數字化與客戶洞察精細化
						</div>
					</div>
				</div>
				<div class="solution solution-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">對話智能中樞</div>
						<div class="t2">
							✅ 整合文字/圖片/音視頻多模態用戶數據<br>
							✅ 重構全生命周期客戶服務場景<br>
							✅ 驅動線索管理與售後服務的智能升級
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/s2-4.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'

export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.solution {
	margin-top: 72px;
	display: flex;
	gap: 40px;
	.pic {
		width: 40%
	}
	.txt {
		flex: 1;
		.t1 {
			font-size: 24px;
			font-weight: 600;
			color: #000;
		}
		.t2 {
			margin-top: 12px;
			color: #000;
		}
	}
}
@media only screen and (max-width: 768px) {
	.solution {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.solution-r {
			flex-direction: column-reverse;
		}
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
